import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';

import { CommonLoader } from '~components/Loaders/CommonLoader';
import { FeatureFlags } from '~constants/featureFlags';
import { ROUTES } from '~router/routePaths';
import { useAwaitableFeatureFlag } from '~utils/hooks/useFeatureFlag';

interface ApprovalsIndexRedirectProps {
  canApproveDriverDays: boolean;
  canApproveJob: boolean;
}

export default observer(function ApprovalsIndexRedirect({
  canApproveDriverDays,
  canApproveJob,
}: ApprovalsIndexRedirectProps) {
  const { isAwaitingTreatment, isFeatureFlagEnabled: chargeBasedSettlements } =
    useAwaitableFeatureFlag({ featureFlagKey: FeatureFlags.chargeBasedSettlements });

  if (canApproveDriverDays) {
    return <Navigate to={ROUTES.approvals.driverDay} replace />;
  }

  if (!canApproveJob) {
    return <Navigate to={ROUTES.approvals.ticketsReview} replace />;
  }

  if (isAwaitingTreatment) {
    return <CommonLoader />;
  }

  return (
    <Navigate
      to={
        chargeBasedSettlements
          ? ROUTES.approvals.approveCharges
          : ROUTES.approvals.approveJobs
      }
      replace
    />
  );
});
